import { render, staticRenderFns } from "./ActionsCreateNewWebsiteDomain.vue?vue&type=template&id=b9be56f8&lang=pug&"
import script from "./ActionsCreateNewWebsiteDomain.vue?vue&type=script&lang=js&"
export * from "./ActionsCreateNewWebsiteDomain.vue?vue&type=script&lang=js&"
import style0 from "./ActionsCreateNewWebsiteDomain.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports